import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { ArrowLeft, Share2, Heart, Bookmark, MessageCircle, MapPin, Clock } from 'lucide-react';
import { useState } from 'react';

const checkpoints = [
  { name: '大理古城', time: 'Day 1 上午' },
  { name: '洱海生态廊道', time: 'Day 1 下午' },
  { name: '喜洲古镇', time: 'Day 2 上午' },
];

const comments = [
  { user: '旅行者A', content: '写得真好，收藏了！', time: '2小时前' },
  { user: '背包客', content: '下个月也要去大理，参考了', time: '昨天' },
];

const TravelogueDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);
  const [collected, setCollected] = useState(false);

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-24 pb-20">
        <div className="flex items-center justify-between mb-4">
          <Button variant="ghost" onClick={() => navigate('/travelogues')} className="text-text-secondary hover:text-primary"><ArrowLeft className="w-4 h-4 mr-1" /> 返回列表</Button>
          <Button variant="ghost" size="sm" onClick={() => {}}><Share2 className="w-4 h-4" /></Button>
        </div>

        <div className="h-[300px] rounded-card overflow-hidden relative mb-6 shadow-card">
          <img src={`https://picsum.photos/seed/dali-lake/1200/600`} alt="" className="w-full h-full mx-auto object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <h1 className="absolute bottom-6 left-6 text-white text-2xl md:text-3xl font-bold">大理的慢时光：在洱海边发呆的七天</h1>
        </div>

        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <Avatar className="w-10 h-10"><AvatarFallback className="bg-primary-light text-primary text-sm">王</AvatarFallback></Avatar>
            <div>
              <p className="text-sm font-medium text-text-primary">旅行家小王</p>
              <p className="text-xs text-text-tertiary flex items-center gap-2"><Clock className="w-3 h-3" /> 2024-01-15 · 阅读5分钟</p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" className={`rounded-btn ${liked ? 'text-danger border-danger' : ''}`} onClick={() => setLiked(!liked)}><Heart className={`w-4 h-4 mr-1 ${liked ? 'fill-danger' : ''}`} /> 342</Button>
            <Button variant="outline" size="sm" className={`rounded-btn ${collected ? 'text-primary border-primary' : ''}`} onClick={() => setCollected(!collected)}><Bookmark className={`w-4 h-4 mr-1 ${collected ? 'fill-primary' : ''}`} /> 56</Button>
          </div>
        </div>

        <Card className="border-0 shadow-card rounded-card bg-white mb-6">
          <CardContent className="p-6 prose prose-slate max-w-none text-text-primary leading-relaxed">
            <p>大理，是一座让人来了就不想走的城市。洱海的波光粼粼，古城的青石板路，还有那一杯杯香醇的咖啡，构成了我最美好的旅行记忆。</p>
            <p>第一天抵达大理，我选择住在洱海边的民宿。推开窗就是湖景，傍晚时分，夕阳把整个湖面染成了金色...</p>
          </CardContent>
        </Card>

        <div className="mb-8">
          <h2 className="text-lg font-bold text-text-primary mb-4 flex items-center gap-2"><MapPin className="w-5 h-5 text-primary" /> 打卡地点</h2>
          <div className="relative pl-6 space-y-4">
            <div className="absolute left-2 top-1 bottom-1 w-0.5 bg-primary/20" />
            {checkpoints.map((c, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-4 top-1 w-3 h-3 rounded-full bg-primary border-2 border-white" />
                <Card className="border-0 shadow-card rounded-card bg-white">
                  <CardContent className="p-3 flex items-center justify-between">
                    <span className="text-sm font-medium text-text-primary">{c.name}</span>
                    <span className="text-xs text-text-tertiary">{c.time}</span>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-bold text-text-primary mb-4 flex items-center gap-2"><MessageCircle className="w-5 h-5 text-primary" /> 评论</h2>
          <div className="space-y-4">
            {comments.map((c, i) => (
              <Card key={i} className="border-0 shadow-card rounded-card bg-white">
                <CardContent className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Avatar className="w-7 h-7"><AvatarFallback className="bg-bg-secondary text-text-secondary text-xs">{c.user[0]}</AvatarFallback></Avatar>
                    <span className="text-sm font-medium text-text-primary">{c.user}</span>
                    <span className="text-xs text-text-tertiary">{c.time}</span>
                  </div>
                  <p className="text-sm text-text-secondary">{c.content}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-lg font-bold text-text-primary mb-4">相关推荐</h2>
          <div className="flex gap-4 overflow-x-auto pb-2">
            {[1, 2, 3].map((i) => (
              <Card key={i} className="min-w-[260px] border-0 shadow-card rounded-card bg-white overflow-hidden cursor-pointer" onClick={() => navigate(`/travelogue/${i}`)}>
                <div className="h-32 bg-bg-secondary">
                  <img src={`https://picsum.photos/seed/travel/400/300`} alt="" className="w-full h-full mx-auto object-cover" />
                </div>
                <CardContent className="p-3">
                  <p className="text-sm font-medium text-text-primary line-clamp-1">相关游记推荐 {i}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelogueDetail;
